module.exports = __webpack_public_path__ + "img/dummy-passport-photo.ea1f4c27.png";